import { queryOptions, type QueryClient } from '@tanstack/react-query';

import { Locale } from 'chaika-enums';

import { UserApi } from '@api/UserApi';
import { store } from '@store';

export const userProfileKeys = {
    all: ['userProfileDetails'] as const,
    lists: () => [...userProfileKeys.all, 'list'] as const,
    byUserId: (userId: string, locale: Locale | undefined) => [...userProfileKeys.lists(), { userId, locale }] as const,
};

export const userProfileQueryOptions = {
    byUserId: (userId: string, locale: Locale | undefined = store.authUser.selectedLanguage) =>
        queryOptions({
            queryKey: userProfileKeys.byUserId(userId, locale),
            queryFn: () =>
                UserApi.get(userId, {
                    withTranslations: true,
                    locale: locale === Locale.Ru ? undefined : locale,
                }),
        }),
};

export function invalidateUserProfile(queryClient: QueryClient, userId: string): Promise<void> {
    return queryClient.invalidateQueries({ queryKey: [...userProfileKeys.lists(), { userId }] });
}
